module.exports = __webpack_public_path__ + "img/flag-1.1348e62b.svg";